import * as yup from 'yup';

export const scheme = yup
  .object({
    inventoryName: yup.string().required('Inventory Name is required'),
    description: yup.string().required('Description is required'),
    stockReward: yup
      .string()
      .required('Stock Available is required')
      .test(
        'is-positive-number',
        'Stock Reward must be a positive number',
        (value) => {
          if (!value) return false;
          const numberValue = Number(value);
          return !isNaN(numberValue) && numberValue > 0;
        }
      ),
    rewardImage: yup.string().required('Reward Image is required'),
    startDate: yup.date().required('Start Date is required'),
    endDate: yup.date().required('End Date is required'),
    status: yup.string().required('Status is required'),
    maxRedeem: yup
      .string()
      .required('Maximum Redeem is required')
      .test(
        'is-positive-number',
        'Maximum Redeem must be a positive number',
        (value) => {
          if (!value) return false;
          const numberValue = Number(value);
          return !isNaN(numberValue) && numberValue > 0;
        }
      ),
    redeemPoint: yup
      .string()
      .required('Redeem Point is required')
      .test(
        'is-positive-number',
        'Redeem Point must be a positive number',
        (value) => {
          if (!value) return false;
          const numberValue = Number(value);
          return !isNaN(numberValue) && numberValue > 0;
        }
      )
  })
  .required();
